export default __webpack_public_path__ + "static/media/survivio-Paladin_Loadout-sm.2d97a08e.gif";